import React, { useEffect } from "react";
import Button from "../components/Button";
import GKLogo from "../images/good-karma-logo.png";
import CornerGoodKarma from "../images/corner/corner-good-karma.webp";

const CAFE_URL = "https://www.thegoodkarmacafe.com";

const GoodKarmaCafe = () => {
  useEffect(() => {
    document.title = "Auburn Road - Good Karma";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  return (
    <>
      <img className="corner-good-karma" src={CornerGoodKarma} alt="" />
      <div className="container karma-page p-t-100">
        <section className="karma-hero">
          <p className="karma-hero__kicker">Society Hill, Philly</p>
          <h1 className="huge-text-no-quote karma-hero__title">
            Good Karma Cafe
          </h1>
          <p className="karma-hero__intro">
            Auburn Road Vineyards welcomes you to Good Karma Cafe and Wine Bar
            Philly, a European-style café for world-class wine, locally made
            beer and spirits, amazing food, and delicious organic and fair trade
            coffee.
          </p>
          <Button className="m-t-20" type="secondary" href={CAFE_URL}>
            Visit the cafe
          </Button>
        </section>

        <section className="karma-story">
          <div className="karma-story__media">
            <img
              className="karma-story__photo"
              src={GKLogo}
              alt="Good Karma Cafe logo"
            />
          </div>
          <div className="karma-story__copy">
            <p>
              Join us for world-class wine, locally made beer and spirits,
              amazing food, and delicious organic and fair trade coffee.
            </p>
            <p className="karma-story__address">
              <a href={CAFE_URL} target="_blank" rel="noreferrer noopener">
                Good Karma Cafe & Wine Bar
                <br />
                Society Hill · 928 Pine Street, Philly
              </a>
            </p>
            <Button type="secondary" href={CAFE_URL}>
              thegoodkarmacafe.com
            </Button>
          </div>
        </section>

        <div className="karma-video">
          <iframe
            src="https://www.youtube.com/embed/JyPwmjRQ2b4?si=iTW0JXe9hSOhGF8P"
            title="Good Karma Cafe video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </>
  );
};

export default GoodKarmaCafe;
